<template>
  <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false" :modal-append-to-body="true" :append-to-body="true">
    <div class="main-box" style="height: 500px">
      <xr-table ref="xrTable" :configure="configure" style="width: 100%;"></xr-table>
      <xr-upload ref="xrUploadDialog" accept=".png,.jpg,.JPEG" :targetId="targetId" :onUploadedClose="true" @confirmMethod="uploadSuccess(arguments)"></xr-upload>
      <!--预览-->
      <img-view ref="imgView" v-if="isImgViewShow"></img-view>
    </div>
  </el-dialog>
</template>
<script>

    import ImgView from './img-view'

    export default {
        name: "index",
        props: ['businessType','businessId','type','pagination'],
        data() {
          return {
            dialogName: '附件',
            dialogVisible: false,
            isImgViewShow: false,
            layoutConfigure:{},
            targetId: '',                               //业务关联表ID
            configure: {
              url: '/web/service?method=tCoreResource_list&targetId=-1',
              isShowSearch: false,
              pagination: true, //允许分页（默认true）
              editUrl: '/web/service?method=tCoreResource_edit',
              idField: 'id',
              defaultNoLoadData: true,
              tableHeight: 400,
              isSelectFirst: true,
              that: this,
              columns: [
                {
                  field: 'ck',
                  width: 60,
                },
                {
                  field: 'fileName',
                  title: '文件名称',
                  condition: {
                    searchType: 'input',
                    searchName: 'fileNameSearch',
                    value:''
                  }
                },
                {
                  field: 'createdByName',
                  title: '上传人',
                  align: 'center',
                  condition: {
                    searchType: 'input',
                    searchName: 'createdByNameSearch',
                    value:''
                  }
                },
                {
                  field: 'createdTime',
                  title: '上传时间',
                  align: 'center',
                  condition: {
                    searchType: 'input',
                    searchName: 'createdTimeSearch',
                    value:''
                  }
                },
                {
                  field: 'operate',
                  title: '操作',
                  width: 200,
                  cellType: 'operate',
                  that: this,
                  operateList: [
                    {
                      text: '下载',
                      iconCls: 'wk wk-add',
                      that: this,
                      display: function(row){
                        return true;
                      },
                      handler: function (row) {
                        this.that.downFile(row.id);
                      }
                    },
                    {
                      text: '预览',
                      iconCls: 'wk wk-add',
                      that: this,
                      handler: function (row) {
                        this.that.viewFile(row.id);
                      }
                    },
                  ]
                }
              ],
              toolbar: [
                {
                  text: '上传附件',
                  iconCls: 'wk wk-add',
                  that: this,
                  handler: function () {
                    this.that.handleAddOpenDialog();
                  }
                },
                {
                  text: '删除附件',
                  iconCls: 'wk wk-danger wk-discard',
                  that: this,
                  handler: function () {
                    this.that.deleteBatch();
                  }
                }
              ]
            }
          }
        },
        components: {
          ImgView
        },
        created(){
          if(this.type == 'view'){
            this.configure.toolbar = [];
          }
          if (!this.pagination && this.pagination === false){
            this.configure.pagination = false
          }
        },
        methods: {
          //初始化
          init(){
            this.dialogVisible = true
            this.$nextTick(()=>{
              this.targetId = this.businessType + '$' + this.businessId;
              this.configure.url = '/web/service?method=tCoreResource_list&targetId=' + this.targetId;
              this.$refs.xrTable.getData();
            })
          },
          //打开新增弹窗
          handleAddOpenDialog(){
            this.$refs.xrUploadDialog.init() //初始化页面
          },
          //导入成功后的操作
          uploadSuccess(msg){
            //关闭弹出窗
            this.$refs.xrTable.getData();
            this.$emit('uploadChange');
          },
          //下载
          downFile(id){
            window.location.href =  process.env.FILE_URL + '/web/getResource/' + id;
          },
          //预览图片
          viewFile(resourceId){
            this.isImgViewShow = true
            this.$nextTick(()=>{
              this.$refs.imgView.init(resourceId)
            })
          },
          //批量删除
          deleteBatch(){
            //获取选中id数组
            let list = this.$refs.xrTable.multipleSelection;
            //判断是否选中
            if(list.length === 0){
              this.$message.warning("请选择需要删除的内容")
            }else {
              this.$confirm(`确定进行批量删除操作?`, '提示',
                {  confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
                let ids = '';
                for(let i = 0;i < list.length;i++){
                  ids = ids + list[i] + ",";
                }
                ids = ids.substring(0,ids.length-1);
                return this.request({
                  method:'post',
                  url:'/web/service',
                  params:{
                    'method':'tCoreResource_deleteBatch',
                    'ids':ids
                  }
                }).then((response) =>{
                  if (response.code === 0) {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 1500,
                      onClose: () => {
                        this.$refs.xrTable.getData();
                        this.$emit('uploadChange');
                      }
                    })
                  } else {
                    this.$message.error(response.msg)
                  }
                })
              }).catch(() => {})
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/XrResource/img-dialog.vue